import { Component } from '@angular/core';
import { SavedPin } from '@models/teranet';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SalePinState } from '@state/sale_pins';
import { combineLatest, Observable } from 'rxjs';
import { uniq } from 'lodash';
import { Select } from '@ngxs/store';
import { MatDialog } from '@angular/material/dialog';
import { CompareNamesModalComponent } from '../compare-names/modal/modal.component';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';
import { TestHooks } from './status.hooks';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';
import { TeranetSyncDetailsComponent } from '../sync/sync.component';

@UntilDestroy()
@Component({
	selector: 'app-teranet-pin-status',
	templateUrl: './status.component.html',
	styleUrls: ['./status.component.scss'],
	standalone: false,
})
export class TeranetPinStatusComponent {
	testHooks = TestHooks;
	ICON = ICON;
	@Select(SalePinState.getSelected) selectedPin$: Observable<SavedPin>;
	@Select(SalePinState.getPurchased) purchasedPins$: Observable<SavedPin[]>;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	public adjacentPins: SavedPin[] = [];
	public purchasedAdjacentPins = false;
	public selectedPin: SavedPin;
	public parcelInstrumentsDiffer?: boolean = null;

	constructor(
		private dialog: MatDialog,
		private navService: NavigationService,
		private drawerService: DrawerService,
	) {
		combineLatest([this.selectedPin$, this.purchasedPins$])
			.pipe(untilDestroyed(this))
			.subscribe(([selectedPin, purchasedPins]) => {
				this.selectedPin = selectedPin;
				const _adjacentPins = selectedPin?.map?.adjacent_parcels?.map(
					(x) => x.pin,
				);

				if (_adjacentPins?.length > 0) {
					this.purchasedAdjacentPins =
						purchasedPins.filter((x) => _adjacentPins.includes(x.pin))?.length >
						0;
				} else {
					this.purchasedAdjacentPins = false;
				}

				if (selectedPin?.parcels?.length > 1) {
					const latestInstrumentNumbers: string[] = selectedPin?.parcels.map(
						(x) => x.latestInstrumentNumber,
					);

					this.parcelInstrumentsDiffer =
						uniq(latestInstrumentNumbers).length > 1;
				}
			});
	}

	openSimilarNamesModal() {
		this.dialog.open(
			CompareNamesModalComponent,
			CompareNamesModalComponent.defaultDialogConfig,
		);
	}

	goToMap() {
		this.navService.goToMatter_TitleSearch_Map(this.matterId);
	}

	goToSync() {
		this.drawerService.openDrawer(TeranetSyncDetailsComponent, {
			title: 'Sync Details',
			size: 'lg',
		});
	}
}
